import { NavLink, useLocation } from 'react-router-dom';
import { resolveModuleFromPath } from '@/config/appNavigation';
import { moduleSharedPath } from '@/config/moduleSharedPaths';

const catalogPages = [
  { page: 'products' as const, label: 'Products', end: true },
  { page: 'categories' as const, label: 'Categories' },
  { page: 'brands' as const, label: 'Brands' },
  { page: 'units' as const, label: 'Units' },
  { page: 'tax-rules' as const, label: 'Tax Rules' },
] as const;

export function ProductCatalogNav() {
  const { pathname } = useLocation();
  const erpModule = resolveModuleFromPath(pathname);

  // Full catalog sub-nav is POS-only; procurement and other modules only mount the products page.
  if (erpModule !== 'POS') {
    return null;
  }

  const links = catalogPages.map((item) => ({
    to: item.page === 'products' ? moduleSharedPath('POS', 'products') : `/pos/${item.page}`,
    label: item.label,
    end: 'end' in item ? item.end : false,
  }));

  return (
    <nav className="mb-6 flex flex-wrap gap-2 border-b border-slate-200 pb-3 dark:border-slate-700">
      {links.map((link) => (
        <NavLink
          key={link.to}
          to={link.to}
          end={link.end}
          className={({ isActive }) =>
            `rounded-lg px-3 py-1.5 text-sm font-medium transition-colors ${
              isActive
                ? 'bg-primary-100 text-primary-800 dark:bg-primary-900/40 dark:text-primary-200'
                : 'text-slate-600 hover:bg-slate-100 dark:text-slate-400 dark:hover:bg-slate-800'
            }`
          }
        >
          {link.label}
        </NavLink>
      ))}
    </nav>
  );
}
